import { Recommendation } from 'models/Recommendation'

export const recommendations: Recommendation[] = [
	{
		name: 'Owen Sikes',
		designation: 'Manager at Landing',
		message:
			'I worked with Kartheek for a year on the mobile engineering team. During that time he became a rockstar developer, shipping out big features, and truly owning projects from start to finish. He has great technical aptitude and an even greater since of ownership. I highly recommend Kartheek and any team would be lucky to have him.',
	},
	{
		name: 'Jeremy Stowe',
		designation: 'Manager at K-Rise',
		message:
			"Kartheek is a knowledgeable developer with great communication skills. In his time at K-Rise, Kartheek was responsible for maintaining a number of applications including Sales Order and Payment Processing for a number of clients. Kartheek excelled at ensuring the client's needs were met and handling the day to day communication. Kartheek is dependable and hard working, and a great self-starter. I highly recommend Kartheek as a valuable addition to any team looking to have him.",
	},
	{
		name: 'Mariel Falk',
		designation: 'Product Manager at K-Rise',
		message:
			'Working with Kartheek at Landing was an absolute joy. He owned transformative mobile feature projects end to end with an attention to detail that everyone else aspires to. His biggest strength is how often he motivates the people around him, opening team-wide discussions on how we can better document/ plan/ and solve important user problems. I sincerely hope we get to work together again!',
	},
	{
		name: 'Alex Hinson',
		designation: 'Co-worker at Landing',
		message:
			"Kartheek was an excellent teammate in our time at Landing. He has a lot of great experience in the mobile space, and wasn't afraid to contribute across the entire stack. He was always willing to dive deep into the details of whatever project he was on, even if he didn't initially have the domain knowledge yet. He has a great sense of ownership, while also able to be very humble in receiving feedback.",
	},
	{
		name: 'Brian Laiche',
		designation: 'Co-worker at Landing',
		message:
			'Kartheek is an incredibly talented engineer I had the honor of working with. His attention to detail made it a breeze to build products with. As a designer I knew any ideas I had, Kartheek would welcome, excited by the challenge to build what ever I presented. A great engineer also cherishes the user experience and I can say Kartheek is one of those. Great products are built together, and Kartheek pushed the designs as much as I pushed the development. Without him, the Landing products would not be what they are today. It would be an honor to work with him again.',
	},
]
